module.exports = __webpack_public_path__ + "assets/img/bp_d_i_4.a01ed4a9.jpg";